import React, { FC } from "react";

// Table View Componet
import { Table } from "../../../../components/table/table-view/Table";
import { TableHeader } from "../../../../components/table/table-view/TableHeader";
import { TableRow } from "../../../../components/table/table-view/TableRow";
import { TableBody } from "../../../../components/table/table-view/TableBody";
import { TableData } from "../../../../components/table/table-view/TableData";
import { DataView } from "../../../../components/table/table-view/DataView";

// No data found
import { NoDataFound } from "../../../../components/common/NoDataFound";
import { TableActionWrapper } from "../../../../components/table/table-action/TableActionWrapper";
import { ViewDetailsAction } from "../../../../components/table/table-action/ViewDetailsAction";

// table header
const tableHeader: any = [
  { fieldID: 1, name: "Name" },
  { fieldID: 2, name: "Banana Type" },
  { fieldID: 3, name: "Estimated Harvest" },
  { fieldID: 4, name: "Already Harvested" },
  { fieldID: 5, name: "Available" },
  { fieldID: 6, name: "View" },
];

// Start Reserve Bunch Table Component
interface ReserveBunchTableProps {
  data: any[];
}

export const ReserveBunchTable: FC<ReserveBunchTableProps> = ({ data }) => {
  
  if (data.length === 0) {
    return <NoDataFound />;
  }

  return (
    <>
      <Table>
        <TableHeader header={tableHeader} />
        <TableBody>
          {data?.map((item: any, index: number) => (
            <TableRow key={item?.id}>
              <TableData width={25}>
                <DataView
                  data={item?.farmer_name}
                  type={"string"}
                  viewLimit={15}
                />
              </TableData>
              <TableData width={25}>
                <DataView
                  data={item?.cropVarietyDetails?.title}
                  type={"string"}
                  viewLimit={30}
                />
              </TableData>
              <TableData width={15}>
                <DataView
                  data={item?.actual_collectable_plants}
                  type={"string"}
                  viewLimit={30}
                />
              </TableData>
              <TableData width={15}>
                <DataView
                  data={item?.currently_collected}
                  type={"string"}
                  viewLimit={30}
                />
              </TableData>
              <TableData width={15}>
                <DataView
                  data={
                    item?.actual_collectable_plants - item?.currently_collected
                  }
                  type={"string"}
                  viewLimit={30}
                />
              </TableData>
              <TableData width={5}>
                <TableActionWrapper>
                  <ViewDetailsAction
                    url={"/reserve-bunch/my-farmers/details-my-farmer"}
                    id={item?.id}
                  />
                </TableActionWrapper>
              </TableData>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
